export default "__VITE_ASSET__P_zqKm0P__"